module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day02_02_stay-a677191adcb83b37fb7bed0ea8aeb692.jpg";